
function setupEntryFields(form) {
 const toggle = () => {
  const absent = form.elements.no_abn.checked;
  form.elements.abn.required = !absent;
  form.elements.abn.disabled = absent;
  form.querySelector('[data-business-address]').hidden = !absent;
  ['address','suburb','state','postcode'].forEach(key => {form.elements[key].required = absent;});
 };
 form.elements.no_abn.addEventListener('change',toggle);
 form.addEventListener('reset',()=>setTimeout(toggle,0));
 toggle();
}
(() => {
  function connect(root) {
    root.querySelectorAll('[data-gnt-registration]').forEach(form => {
      if (form.dataset.connected) return;
      form.dataset.connected = 'true';
      const fieldset = form.querySelector('fieldset');
      const status = form.querySelector('[role=status]');
      const button = form.querySelector('[type=submit]');
      let saving = false;
      fieldset.disabled = false;
      setupEntryFields(form);
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (saving || !form.reportValidity()) return;
        const data = Object.fromEntries(new FormData(form));
        ['terms','no_abn','marketing_email','marketing_sms'].forEach(key => data[key] = form.elements[key].checked);
        data.customer_confirmed = form.elements.customer_confirmed.value === 'yes';
        saving = true;
        fieldset.disabled = true;
        status.hidden = false;
        status.textContent = 'Saving your registration…';
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 30000);
        let saved = false;
        try {
          const response = await fetch('/apps/gnt-events/register', {
            method: 'POST', headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(data), signal: controller.signal
          });
          let result;
          try { result = await response.json(); }
          catch (_) { throw new Error('We could not confirm your registration. Please contact the store or try again.'); }
          if (!response.ok || !result.reference) throw new Error(result.error || 'We could not confirm your registration. Please contact the store or try again.');
          saved = true;
          button.textContent = 'Registration saved';
          status.textContent = 'You’re registered! Your reference is ' + result.reference + '. Please keep this reference and check in with staff on arrival. Staff eligibility approval is required for prize entry.';
        } catch (error) {
          status.textContent = error.name === 'AbortError'
            ? 'The request timed out, so we could not confirm whether it saved. Please contact the store to confirm before submitting again.'
            : (error.message || 'Unable to connect. Please try again or contact the store.');
        } finally {
          clearTimeout(timeout);
          saving = false;
          fieldset.disabled = saved;
          status.focus();
        }
      });
    });
  }
  connect(document);
  document.addEventListener('shopify:section:load', event => connect(event.target));
})();
